import { render, staticRenderFns } from "./SessionsTopNotDiscoverPostsTable.vue?vue&type=template&id=730d1f56&scoped=true&"
import script from "./SessionsTopNotDiscoverPostsTable.vue?vue&type=script&lang=js&"
export * from "./SessionsTopNotDiscoverPostsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730d1f56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VTooltip})
